// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__78mQw","select":"Header_select__3V0my","clinic":"Header_clinic__1159n"};